import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0" }, "Số dư đầu năm", -1)
const _hoisted_3 = { class: "text-end mb-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Đơn giá")
], -1)
const _hoisted_5 = { class: "text-end mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "S/L nhập")
], -1)
const _hoisted_7 = { class: "text-end mb-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Thành tiền")
], -1)
const _hoisted_9 = { class: "text-end mb-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-center mb-0" }, "ĐVT", -1)
const _hoisted_11 = { class: "d-flex align-items-center justify-content-center mb-0" }
const _hoisted_12 = { class: "d-flex justify-content-center flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationDialog, {
      title: "Bạn có chắc chắn muốn xóa dữ liệu này?",
      width: "20%",
      "is-display": _ctx.isDeleteVatTuDialogDisplay,
      onOnConfirmButtonClick: _ctx.confirmDelete,
      onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDeleteVatTuDialogDisplay = false)),
      onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDeleteVatTuDialogDisplay = false))
    }, {
      default: _withCtx(() => [
        (_ctx.deletingVatTu)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(_ctx.deletingVatTu.ten_vat_tu), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "cell-class-name": _ctx.isTextDangerColumn,
      "empty-text": "Chưa có vật tư",
      "max-height": "800",
      size: "small",
      "cell-style": {padding: '0', height: '15px'},
      data: _ctx.vatTuItems,
      border: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "STT",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.indexCal(scope.$index, _ctx.curPage, _ctx.perPage)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "ID",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.id), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Tên",
          width: "220"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ten_vat_tu), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Mã",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ma_vat_tu), 1)
          ]),
          _: 1
        }),
        (!_ctx.vatTuPhieuNhapDetail)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "Thu hồi",
              width: "120"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.vatTuItems[scope.$index].thu_hoi,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].thu_hoi) = $event),
                  disabled: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.vatTuPhieuNhapDetail)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              label: "C/ty duyệt",
              width: "120"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.vatTuItems[scope.$index].cong_ty_duyet,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].cong_ty_duyet) = $event),
                  disabled: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.vatTuPhieuNhapDetail)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              label: "Trạng thái",
              width: "90"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.isValidLabel(scope.row)), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showSoDu && !_ctx.vatTuPhieuNhapDetail)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              label: "Số dư đầu năm",
              width: "130"
            }, {
              header: _withCtx(() => [
                _hoisted_2
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.showSoDu ? _ctx.formatCurrencyAndQuantity(scope.row.so_du_dau_nam) : '-'), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, { width: "150" }, {
          header: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_5, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.showPrice ? _ctx.formatCurrencyAndQuantity(scope.row.don_gia, false) : '-'), 1)
            ])
          ]),
          _: 1
        }),
        (_ctx.vatTuPhieuNhapDetail)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 4,
              width: "150"
            }, {
              header: _withCtx(() => [
                _hoisted_6
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_7, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrencyAndQuantity(scope.row.so_luong)), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.vatTuPhieuNhapDetail)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 5,
              width: "150"
            }, {
              header: _withCtx(() => [
                _hoisted_8
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_9, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrencyAndQuantity(+scope.row.so_luong * +scope.row.don_gia)), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, { width: "100" }, {
          header: _withCtx(() => [
            _hoisted_10
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_11, _toDisplayString(scope.row.don_vi_tinh ? scope.row.don_vi_tinh : '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { width: _ctx.actionColumnWidth }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_RouterLink, {
                to: {
              name: 'supply-detail',
              params: {
                id: scope.row.id,
              },
            },
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ButtonCustom, {
                    "color-type": _ctx.ButtonTypeColors.INFO,
                    "button-type": _ctx.ButtonsType.INFO
                  }, null, 8, ["color-type", "button-type"])
                ]),
                _: 2
              }, 1032, ["to"]),
              _createVNode(_component_RouterLink, {
                to: {
              name: 'update-supply',
              params: {
                id: scope.row.id,
              },
            },
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  (_ctx.isVatTuEditable)
                    ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                        key: 0,
                        "color-type": _ctx.ButtonTypeColors.SUCCESS,
                        "button-type": _ctx.ButtonsType.EDIT
                      }, null, 8, ["color-type", "button-type"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]),
          _: 1
        }, 8, ["width"])
      ]),
      _: 1
    }, 8, ["cell-class-name", "data"])), [
      [_directive_loading, _ctx.isLoading]
    ])
  ], 64))
}